import { motion, useReducedMotion, type HTMLMotionProps } from 'framer-motion';
import { type ReactNode } from 'react';
import { cn } from '@/shared/lib/cn';

/**
 * Motion wrapper for route-level transitions. Pairs with <AnimatePresence>
 * in the AppShell so modules slide/fade in on navigation. When the user has
 * `prefers-reduced-motion: reduce` we skip all motion and just render a
 * normal div.
 */
export function PageTransition({
  children,
  className,
  ...rest
}: { children: ReactNode; className?: string } & Omit<HTMLMotionProps<'div'>, 'children'>) {
  const reduce = useReducedMotion();

  if (reduce) {
    return <div className={cn('h-full', className)}>{children}</div>;
  }

  return (
    <motion.div
      initial={{ opacity: 0, y: 10 }}
      animate={{ opacity: 1, y: 0 }}
      exit={{ opacity: 0, y: -8 }}
      transition={{ duration: 0.22, ease: [0.22, 1, 0.36, 1] }}
      className={cn('h-full', className)}
      {...rest}
    >
      {children}
    </motion.div>
  );
}
